<template>
  <div class="form_model">
    <el-form
      :model="modelForm"
      :style="{ width: setW }"
      ref="modelForm"
      :inline="true"
    >
      <el-row>
        <el-col
          v-for="(config, index) in formSetting"
          :key="index"
          :span="config.span"
          @click.native.stop="$emit('activeItem', config)"
          :class="config.refs + '--' + new Date().getTime()"
        >
          <el-form-item
            :label="config.label"
            :prop="config.prop || config.key"
            :rules="config.regList"
            :required="config.required"
            v-if="config.isShow"
          >
            <slot name="content"></slot>
            <!-- 输入框 -->
            <el-input
              v-if="config.type == 'input'"
              :disabled="config.disabled"
              :placeholder="config.placeholder"
              v-model="modelForm[config.key]"
              :isShow="config.isShow"
              :clearable="config.clearable"
              :suffix-icon="config.suffixIcon"
              :prefix-icon="config.prefixIcon"
              :size="config.size"
              :show-password="config.showPassword"
              :maxlength="config.maxlength ? config.maxlength : 9999999999"
              :show-word-limit="config.showWordLimit"
              :readonly="config.readonly"
              @change="$emit('change', modelForm, config)"
            >
              <template v-if="config.prepend" #prepend>
                {{ config.prepend }}
              </template>
              <template v-if="config.append" #append>
                {{ config.append }}
              </template>
            </el-input>
            <!-- 多行文本 -->
            <el-input
              type="textarea"
              v-if="config.type == 'textarea'"
              :disabled="config.disabled"
              :placeholder="config.placeholder"
              :clearable="config.clearable"
              :isShow="config.isShow"
              v-model="modelForm[config.key]"
              :autosize="config.autosize"
              :maxlength="config.maxlength"
              :readonly="config.readonly"
              :show-word-limit="config.showWordLimit"
              @change="$emit('change', modelForm, config)"
            >
            </el-input>
            <!-- 下拉框 -->
            <el-select
              v-if="config.type == 'select' && config.selectData"
              :disabled="config.disabled"
              v-model="modelForm[config.key]"
              :isShow="config.isShow"
              :placeholder="config.placeholder"
              :clearable="config.clearable"
              :multiple="config.multiple"
              :multiple-limit="config.multipleLimit"
              :filterable="config.filterable"
              :allow-create="config.allowCreate"
              default-first-option
              @change="$emit('change', modelForm, config)"
              @remove-tag="(val) => $emit('remove-tag', val)"
              @clear="$emit('clear')"
            >
              <template v-if="$slots.prefix" #prefix>
                <slot name="prefix"></slot>
              </template>
              <el-option
                :value="el[config.propsState.value]"
                v-for="(el, i) in config.selectData"
                :key="i"
                :label="el[config.propsState.label]"
                :disabled="el.disabled"
              >
                <slot name="customize"></slot>
              </el-option>
            </el-select>
            <!-- 单选框 -->
            <el-radio-group
              v-if="config.type == 'radio'"
              :size="config.size"
              :disabled="config.disabled"
              :text-color="config.textColor"
              :fill="config.fill"
              v-model="modelForm[config.key]"
              @change="$emit('change', modelForm, config)"
            >
              <template v-if="config.optionType == 'default'">
                <el-radio
                  :border="config.border"
                  v-for="(el, i) in config.selectData"
                  :label="el.value"
                  :key="i"
                  >{{ el.label }}</el-radio
                >
              </template>
              <template v-else>
                <el-radio-button
                  v-for="(el, i) in config.selectData"
                  :label="el.value"
                  :key="i"
                  >{{ el.label }}</el-radio-button
                >
              </template>
            </el-radio-group>
            <!-- 多选框 -->
            <el-checkbox-group
              v-if="config.type == 'checkbox' && config.selectData"
              :isShow="config.isShow"
              :size="config.size"
              :min="config.min"
              :max="config.max"
              :text-color="config.textColor"
              :fill="config.fill"
              :disabled="config.disabled"
              v-model="searchMoreValue"
              @change="$emit('change', searchMoreValue, config)"
            >
              <template v-if="config.optionType == 'default'">
                <el-checkbox
                  v-for="(el, i) in config.selectData"
                  :label="el.value"
                  :key="i"
                  :disabled="el.disabled"
                  :border="config.border"
                  :size="el.size"
                  :checked="el.checked"
                  :indeterminate="el.indeterminate"
                >
                  {{ el.label }}
                </el-checkbox>
              </template>
              <template v-else>
                <el-checkbox-button
                  v-for="(el, i) in config.selectData"
                  :label="el.value"
                  :key="i"
                  :disabled="el.disabled"
                >
                  {{ el.label }}
                </el-checkbox-button>
              </template>
            </el-checkbox-group>
            <!-- 级联选择器 -->
            <el-cascader
              v-if="config.type == 'cascader'"
              v-model="modelForm[config.key]"
              :size="config.size"
              :isShow="config.isShow"
              :options="config.selectData"
              :disabled="config.disabled"
              :clearable="config.clearable"
              :show-all-levels="config.showAllLevels"
              :collapse-tags="config.collapseTags"
              :filterable="config.filterable"
              :separator="config.separator"
              :filter-method="
                (node, keyword) => $emit('filter-method', node, keyword)
              "
              :props="config.propsState"
              @change="$emit('change', modelForm, config)"
              @remove-tag="(val) => $emit('remove-tag', val)"
            >
              <template #default="{ node, data }">
                <slot :node="node" :data="data"></slot>
              </template>
            </el-cascader>
            <!-- 开关 -->
            <el-switch
              v-if="config.type == 'switch'"
              v-model="modelForm[config.key]"
              :isShow="config.isShow"
              :disabled="config.disabled"
              :active-color="config.activeColor"
              :inactive-color="config.inactiveColor"
              :active-text="config.activeText"
              :inactive-text="config.inactiveText"
              :active-value="config.activeValue"
              :inactive-value="config.inactiveValue"
              @change="$emit('change', modelForm, config)"
            >
            </el-switch>
            <!-- 计数器 -->
            <el-input-number
              v-if="config.type == 'number'"
              v-model="modelForm[config.key]"
              :disabled="config.disabled"
              :size="config.size"
              :isShow="config.isShow"
              :min="config.min"
              :max="config.max"
              :step="config.step"
              :precision="config.precision"
              :controls-position="config.controlsPosition"
              @change="$emit('change', modelForm, config)"
              @select="$emit('change', modelForm, config)"
            ></el-input-number>
            <!-- 滑块 -->
            <el-slider
              v-if="config.type == 'slider'"
              v-model="modelForm[config.key]"
              :show-tooltip="config.showTooltip"
              :disabled="config.disabled"
              :step="config.step"
              :isShow="config.isShow"
              :show-stops="config.showStops"
              :show-input="config.showInput"
              :range="config.range"
              :min="config.min"
              :max="config.max"
              :vertical="config.vertical"
              :height="config.height"
              :marks="config.marks"
              :format-tooltip="formatTool"
              @change="$emit('change', modelForm, config)"
            ></el-slider>
            <!-- 固定时间选择 -->
            <el-time-select
              v-if="config.type == 'fixTime'"
              v-model="modelForm[config.key]"
              :placeholder="config.placeholder"
              :disabled="config.disabled"
              :isShow="config.isShow"
              :readonly="config.readonly"
              :prefix-icon="config.prefixIcon"
              :clearable="config.clearable"
              :size="config.size"
              :picker-options="config.pickerOptions"
              :default-value="config.defaultValue"
              @change="$emit('change', modelForm, config)"
            >
            </el-time-select>
            <!-- 时间选择 -->
            <el-time-picker
              v-if="config.type == 'timeSelect'"
              v-model="modelForm[config.key]"
              :placeholder="config.placeholder"
              :disabled="config.disabled"
              :isShow="config.isShow"
              :readonly="config.readonly"
              :prefix-icon="config.prefixIcon"
              :clearable="config.clearable"
              :size="config.size"
              :picker-options="config.pickerOptions"
              :default-value="config.defaultValue"
              @change="$emit('change', modelForm, config)"
            >
            </el-time-picker>
            <!-- 时间范围选择 -->
            <el-time-picker
              v-if="config.type == 'timeRangeSelect'"
              v-model="modelForm[config.key]"
              :placeholder="config.placeholder"
              :disabled="config.disabled"
              :isShow="config.isShow"
              :format="config.format"
              :readonly="config.readonly"
              :prefix-icon="config.prefixIcon"
              :clearable="config.clearable"
              :value-format="config.valueFormat"
              :size="config.size"
              :is-range="config.isRange"
              :start-placeholder="config.startPlaceholder"
              :end-placeholder="config.endPlaceholder"
              :range-separator="config.rangeSeparator"
              :default-value="config.defaultValue"
              @change="$emit('change', modelForm, config)"
            >
            </el-time-picker>
            <!-- 日期选择 -->
            <el-date-picker
              v-if="config.type == 'date'"
              :type="config.dataType"
              v-model="modelForm[config.key]"
              :isShow="config.isShow"
              :disabled="config.disabled"
              :clearable="config.clearable"
              :size="config.size"
              :placeholder="config.placeholder"
              :picker-options="config.pickerOptions"
              :format="config.format"
              :prefix-icon="config.prefixIcon"
              :readonly="config.readonly"
              :value-format="config.valueFormat"
              @change="$emit('change', modelForm, config)"
            >
            </el-date-picker>
            <!-- 日期范围选择 -->
            <el-date-picker
              v-if="config.type == 'daterange'"
              :type="config.dataType"
              v-model="modelForm[config.key]"
              :isShow="config.isShow"
              :disabled="config.disabled"
              :clearable="config.clearable"
              :size="config.size"
              :placeholder="config.placeholder"
              :picker-options="config.pickerOptions"
              :format="config.format"
              :readonly="config.readonly"
              :prefix-icon="config.prefixIcon"
              :range-separator="config.rangeSeparator"
              :start-placeholder="config.startPlaceholder"
              :end-placeholder="config.endPlaceholder"
              :value-format="config.valueFormat"
              :default-value="config.defaultValue"
              @change="$emit('change', modelForm, config)"
            >
            </el-date-picker>
            <!-- 评分 -->
            <el-rate
              v-if="config.type == 'rate'"
              v-model="modelForm[config.key]"
              :disabled="config.disabled"
              :max="config.max"
              :show-score="config.showScore"
              :text-color="config.textColor"
              :allow-half="config.allowHalf"
              :show-text="config.showText"
              @change="$emit('change', modelForm, config)"
            >
            </el-rate>
            <!-- 颜色选择 -->
            <el-color-picker
              v-if="config.type == 'colorPicker'"
              v-model="modelForm[config.key]"
              :disabled="config.disabled"
              :size="config.size"
              :show-alpha="config.showAlpha"
              :color-format="config.colorFormat"
              @change="$emit('change', modelForm, config)"
            >
            </el-color-picker>
            <!-- 上传 -->
            <uploadFiles
              v-if="config.type == 'upload'"
              :uploadData="config"
              @preview="() => $emit('preview')"
              @responed="(data) => $emit('responed', data)"
              @error="(file, fileList) => $emit('error', file, fileList)"
              @onProgress="
                (event, file, fileList) =>
                  $emit('onProgress', event, file, fileList)
              "
              @change="
                (file, fileList) =>
                  $emit('changeFile', file, fileList, config.key)
              "
              @fileList="(fileList) => $emit('fileList', fileList)"
              @fileListChange="(ids) => $emit('fileListChange', ids)"
              @fileUrl="(url) => $emit('fileUrl', url)"
              @beforeUpload="(file) => $emit('beforeUpload', file)"
              @beforeRemove="
                (file, fileList) => $emit('beforeRemove', file, fileList)
              "
              @pdfSrc="pdfView"
              @closePdfModel="closePdf"
            ></uploadFiles>
            <!-- 上传附件支持预览 -->
            <!-- 富文本编辑 -->
            <VueUeditorWrap
              v-if="config.type == 'editor'"
              v-model="modelForm[config.key]"
              :editor-id="config.editorId"
              :disabled="config.disabled"
              :ref="config.refs"
              :config="config"
              @before-init="(string) => $emit('before-init', string)"
              @ready="(val) => $emit('ready', val)"
            >
            </VueUeditorWrap>
          </el-form-item>
        </el-col>
        <slot name="customizeSlot"></slot>
      </el-row>
    </el-form>
    <!-- pdf预览 -->
    <div class="onlineHelp cg-box" v-if="pdfModel">
      <div class="tools">
        <div class="page">
          第 {{ pdfInfo.pageNum }} /{{ pdfInfo.pageTotalNum }}页
        </div>
        <el-input
          v-model.number="pdfInfo.goPageNum"
          style="width: 70px; margin-right: 8px"
        ></el-input>
        <el-button type="success" @click.stop="goPage"> 前往</el-button>
        <el-button type="primary" @click.stop="prePage"> 上一页</el-button>
        <el-button type="primary" @click.stop="nextPage"> 下一页</el-button>
      </div>
      <div class="pdf-box">
        <pdf
          ref="pdf"
          :src="pdfInfo.pdfSrc"
          :page="pdfInfo.pageNum"
          @num-pages="pdfInfo.pageTotalNum = $event"
        >
        </pdf>
      </div>
    </div>
    <!-- 图片预览 -->
    <imgView
      :imgShow="imgInfo.imgShow"
      :imgSrc="imgInfo.imgSrc"
      @closeModel="imgInfo.imgShow = false"
    />
    <!-- txt预览 -->
    <txtView
      :txtShow="txtInfo.txtShow"
      :txtContent="txtInfo.txtContent"
      @closeModel="txtInfo.txtShow = false"
    />
  </div>
</template>

<script>
import uploadFiles from "@/components/utils/upload";
import imgView from "@/components/imgView";
import txtView from "@/components/txtView";
// import pdf from "vue-pdf";
export default {
  components: { uploadFiles, imgView, txtView },
  data() {
    return {
      modelForm: {},
      modelRules: {},
      valids: [],
      pdfModel: false,
      //表单宽度
      setW: "100%",
      //pdf分页
      pdfInfo: {
        pdfSrc: "",
        pageNum: 1,
        pageTotalNum: 1,
        goPageNum: 1,
      },
      //img
      imgInfo: { imgShow: false },
      txtInfo: { txtShow: false },
    };
  },
  props: {
    formSetting: {
      require: true,
      default: () => {
        return [];
      },
    },
    value: {
      require: true,
      default: {},
    },
  },
  watch: {
    //默认值
    "config.defaultValue": {
      handler() {
        this.searchValue = this.config.defaultValue;
      },
      deep: true,
    },
    value: {
      handler(newValue) {
        this.modelForm = JSON.parse(JSON.stringify(newValue));
      },
      deep: true,
    },
  },
  created() {
    //单个值
    this.modelForm = JSON.parse(JSON.stringify(this.value));
  },
  mounted() {
    //自定义表单校验
    this.$nextTick(() => {
      for (let a in this.formSetting) {
        this.formSetting[a].regList = this.formSetting[a].regList.map((b) => {
          if (!!b.pattern) {
            let testValid = JSON.parse(JSON.stringify(b));
            b = {
              validator: (rule, value, callback) => {
                if (this.modelForm[a]) {
                  //new RegExp不需要前后斜杠/ /
                  let z_reg = new RegExp(testValid.pattern);
                  if (z_reg.test(this.modelForm[a])) {
                    callback();
                  } else {
                    callback(testValid.message);
                  }
                }
              },
              trigger: "blur",
            };
          }
          return b;
        });
      }
    });
  },
  methods: {
    timeStart(val) {
      this.searchMoreValue[0] = val;
      this.$emit("startChange", val);
    },
    endTime(val) {
      this.searchMoreValue[1] = val;
      this.$emit("endChange", val);
    },
    //滑块格式化配置
    formatTool() {
      if (this.config.formatTooltip) {
        this.$emit("formatTooltip");
      } else {
        () => {
          return 0;
        };
      }
    },
    //表单校验
    formVaild() {
      return new Promise((resolve) => {
        console.log(22);
        this.$nextTick(() => {
          console.log(this.$refs.modelForm.validate);
          this.$refs.modelForm.validate((valid) => {
            console.log(valid);
            if (valid) {
              resolve(this.modelForm);
            } else {
              console.log("error submit!!");
              return false;
            }
          });
        });
      });
    },
    // 取消校验
    cancelValid() {
      this.$refs.modelForm.resetFields();
    },
    //预览
    pdfView(val, type) {
      if (type == "png" || type == "jpg" || type == "jpeg") {
        this.imgInfo = {
          imgSrc: val,
          imgShow: true,
        };
      } else if (type == "txt") {
        this.txtInfo = {
          txtContent: val,
          txtShow: true,
        };
      } else {
        //pdf预览
        this.pdfInfo.pdfSrc = "";
        this.$emit("changeWid", "90%");
        setTimeout(() => {
          this.$set(this, "setW", "50%");
          this.pdfModel = true;
          this.pdfInfo.pdfSrc = val;
        }, 200);
      }
    },
    //关闭pdf预览
    closePdf() {
      this.$set(this, "setW", "100%");
      this.pdfModel = false;
      this.$forceUpdate();
    },
    // 前往页数
    goPage() {
      if (
        !this.pdfInfo.goPageNum ||
        /\D/.test(this.pdfInfo.goPageNum) ||
        this.pdfInfo.goPageNum < 1 ||
        this.pdfInfo.goPageNum > this.pdfInfo.pageTotalNum
      ) {
        this.msgError("输入页码有误");
        return;
      }
      this.pdfInfo.pageNum = this.pdfInfo.goPageNum;
    },
    // 上一页
    prePage() {
      var page = this.pdfInfo.pageNum;
      page = page > 1 ? page - 1 : this.pdfInfo.pageTotalNum;
      this.pdfInfo.pageNum = page;
    },
    // 下一页
    nextPage() {
      var page = this.pdfInfo.pageNum;
      page = page < this.pdfInfo.pageTotalNum ? page + 1 : 1;
      this.pdfInfo.pageNum = page;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/form.scss";
.form_model {
  display: flex;
}
.onlineHelp {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  flex: 1;
  .tools {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    .page {
      display: inline-block;
      margin-right: 10px;
    }
  }
  .pdf-box {
    height: 100%;
    overflow: auto;
    width: 90%;
  }
}
</style>
